import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { useRef } from "react";

const RPModal = ({ open, setOpen, Component,refs = null, forms, title }) => {

  return (
    <Dialog className="relative z-40" open={open} onClose={setOpen}>
      <DialogBackdrop
        transition
        className="fixed inset-0 z-30 bg-black/55 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div ref={refs} className="fixed inset-0 z-40 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-2 text-center sm:items-center sm:p-4">
          <DialogPanel
            transition
            className="relative w-full transform overflow-y-auto rounded-xl border border-wa-border bg-wa-panel2 px-3 pb-4 pt-4 text-left text-wa-text shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:max-h-[92vh] sm:max-w-6xl sm:rounded-2xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
              <button
                type="button"
                className="rounded-md bg-wa-panel2 text-wa-muted hover:text-wa-text focus:outline-none focus:ring-2 focus:ring-wa-accent focus:ring-offset-2 focus:ring-offset-wa-panel2"
                onClick={() => setOpen(false)}
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="">
              <DialogTitle
                as="h3"
                className="sr-only"
              >
                {title || "Dialoog"}
              </DialogTitle>
              {Component}
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};

export default RPModal;
